export default __webpack_public_path__ + "static/media/empty-matching-animated.28f0948b.svg";